var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-bubble__button",class:{ 'chat-bubble__button--active': _vm.bookmarked },on:{"click":_vm.handleSave}},[_c('p',[_c('i',{staticClass:"iconfont",class:_vm.bookmarked ? 'icon-bookmark-solid' : 'icon-bookmark'})])])}
var staticRenderFns = []

export { render, staticRenderFns }